import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { ProfileFormFields } from '@/components/profile/ProfileFormFields';
import type { PlayerProfile } from '@swiss-magic/shared-types';

interface PlayerProfileViewerModalProps {
  open: boolean;
  loading: boolean;
  profile: PlayerProfile | null;
  onClose: () => void;
}

export function PlayerProfileViewerModal({
  open,
  loading,
  profile,
  onClose,
}: PlayerProfileViewerModalProps) {
  const { t } = useTranslation('director');
  const fallbackTitle = t('players_page.profile_viewer.fallback_title');
  const title = profile
    ? `${profile.firstName} ${profile.lastName}`.trim() || fallbackTitle
    : fallbackTitle;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="player-profile-viewer-modal"
        className="inset-0 max-w-full w-full h-full max-h-full translate-x-0 translate-y-0 rounded-none overflow-y-auto sm:inset-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:max-w-2xl sm:w-auto sm:h-auto sm:max-h-[90vh] sm:rounded-lg"
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        {loading && (
          <p
            data-testid="player-profile-viewer-loading"
            className="py-8 text-center text-sm text-muted-foreground"
          >
            {t('players_page.profile_viewer.loading')}
          </p>
        )}

        {!loading && profile && (
          <ProfileFormFields
            values={{
              firstName: profile.firstName ?? '',
              lastName: profile.lastName ?? '',
              city: profile.city ?? '',
              country: profile.country ?? '',
              bio: profile.bio ?? '',
              avatarUrl: profile.avatarUrl,
              chessRating:
                profile.chessRating != null ? String(profile.chessRating) : '',
              chessFideId:
                profile.chessFideId != null ? String(profile.chessFideId) : '',
              chessClub: profile.chessClub ?? '',
              sex: profile.sex ?? '',
              birthYear:
                profile.birthYear != null ? String(profile.birthYear) : '',
              chessTitle: profile.chessTitle ?? '',
              backgammonClub: profile.backgammonClub ?? '',
              bmabTitle: profile.bmabTitle ?? '',
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
